import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";

function PurchaserInfoSummary({
  nameOnTicket,
  email,
}: PurchaserInfoSummaryProps) {
  const { t } = useTranslation("checkout");
  return (
    <Box>
      <Box>
        <Text>{t("Your order and receipt will be sent to")}</Text>
      </Box>
      <Box mt="lg" mb="lg">
        <Text fontSize="sm">{nameOnTicket}</Text>
        <Text fontWeight={700}>{email}</Text>
      </Box>
    </Box>
  );
}

export default PurchaserInfoSummary;

type PurchaserInfoSummaryProps = {
  nameOnTicket: string;
  email: string;
};
